module.exports = __webpack_public_path__ + "media/applicants/demo_mode-83f9278d.png";